import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Stack,
  CircularProgress,
  Modal,
  Box
} from "@mui/material";
import {
  ExpandMore,
  CheckCircle,
  TaskAlt,
  KeyboardDoubleArrowLeftSharp,
  Add,
  AddCircle,
  RemoveCircle,
  Cancel,
  InfoRounded,
  HighlightOff,
  DeleteOutlined
} from '@mui/icons-material';


import AppContext from "./AppContext";
import ImageZoom from "react-image-zooom";
import ReactImageMagnify from 'react-image-magnify';
import axios from "axios";

export default function AppProvider(props) {
  // JSON data of each section
  const [SubsetJson, setSubsetJson] = useState({});
  const [BreakerJson, setBreakerJson] = useState({});
  const [BranchBreakerJson, setBranchBreakerJsonData] = useState({});
  const [CustomGrpsJsonList, setCustomGrpsJsonList] = useState([]);

  // Each Questions list (Parent and dependent questions)
  const [AllQuestionsList, setAllQuestionsList] = useState([]);
  const [CustomGroupsAllQueList, setCustomGroupsAllQueList] = useState([]);

  // Parent(Independent) questions only
  const [ParentQuestionList, setParentQuestionList] = useState([]);

  // State contains Questions to be render on screen
  const [ConfigQuestionsList, setConfigQuestionsList] = useState([]);
  const [BreakerQueList, setBreakerQueList] = useState([]);
  const [BranchBreakerQueList, setBranchBreakerQueList] = useState([]);
  const [CustomGroupsQueList, setCustomGroupsQueList] = useState([]);

  // Answers object that has been selected by user
  const [QueValueObj, setQueValueObj] = useState({});
  const [BreakerValueObj, setBreakerValueObj] = useState({});
  const [BranchBreakerValueObj, setBranchBreakerValueObj] = useState({});
  const [CustomGroupsValueObjList, setCustomGroupsValueObjList] = useState([]);
  const [InfoQueValueObj, setInfoQueValueObj] = useState({});

  // List of cart items
  const [Parts, setParts] = useState([]);
  const [Accessories, setAccessories] = useState([]);
  const [MainBreakersList, setMainBreakersList] = useState([]);
  const [BranchBreakersList, setBranchBreakersList] = useState([]);
  const [ExtraAccList, setExtraAccList] = useState([]);

  // Cart items with Quantity details
  const [AccessoriesCartCount, setAccessoriesCartCount] = useState(0);
  const [AccCartQtyInfoArr, setAccCartQtyInfoArr] = useState([]);
  const [AccessoriesCartInfoArr, setAccessoriesCartInfoArr] = useState([]);

  // Items Cart count (that has been selected by user)
  const [BranchBreakerCartCnt, setBranchBreakerCartCnt] = useState(0);
  const [BranchBrkCartInfoArr, setBranchBrkCartInfoArr] = useState([]);
  const [IsSubsetInfoDrawerOpen, SetSubsetInfoDrawerOpen] = useState(true);

  // Item details of Custom Accessories groups cart list
  const [CustomGrpCartItemsList, setCustomGrpCartItemsList] = useState([]);

  // States to manage Extra accessories details
  const [ExtraAccessoriesListJsonData, setExtraAccessoriesListJsonData] =
    useState([]);
  const [ExtraAccCartCount, setExtraAccCartCount] = useState(0);
  const [ExtraAccCartInfoArr, setExtraAccCartInfoArr] = useState([]);
  const [ExtraAccCatCartList, setExtraAccCatCartList] = useState([]);
  const [ExtraAccListExpanded, setExtraAccListExpanded] = useState(true);

  // Flags of Cart accordion
  const [PartsListExpanded, setPartsListExpanded] = useState(true);
  const [AccListExpanded, setAccListExpanded] = useState(true);
  const [MainBrkListExpanded, setMainBrkListExpanded] = useState(true);
  const [BranchBrkListExpanded, setBranchBrkListExpanded] = useState(true);

  const [productForImageModal, setProductForImageModal] = useState({});
  const [imageModalLoader, setImageModalLoader] = useState(true);

  const [ProductManualCatData, setProductManualCatData] = useState({});
  const [ExtraAccSectionExpanded, setExtraAccSectionExpanded] = useState({});

  const [toggleContents, setToggleContents] = useState("United States");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryFlag, setSelectedCountryFlag] = useState("us");
  const [Product] = useState([]);
  const [searchtxt, setSearchtxt] = useState("");
  const [showGridView, setShowGridView] = useState(true);
  const [DistKey, setDistKey] = useState(0);

  const [IsFromEZOwnHomePage, setIsFromEZOwnHomePage] = React.useState(true);
  const [HeaderProductJson, setHeaderProductJson] = useState();
  
  const [ initialBooleanValue, setInitialBooleanValue] = React.useState(false);

  // product subset state
  const [productSubset, setProductSubset] = useState([]);

  // leftside html url 
  const [ htmlUrl, sethtmlUrl] = React.useState(`${process.env.PUBLIC_URL}/asset/Leftside/index.html`);
  // const htmlUrl = "./Leftside/index.html"

  const loadSubsetJSONData = async (SubsetName, PartIdName) => {
    let PartId = PartIdName.split(".")[1];
    let ProductManualCat = {};


    // await import(`../JSONData/${PartId}/EZ3_${PartId}_ManualCat.json`)
    await axios.get(`${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_ManualCat_${localStorage.getItem("lang")}.json`)
    // await axios.get(`${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_ManualCat.json`)
      .then((res) => {
        ProductManualCat = { ...res.data };
      })
      .catch((err) => {
        // console.log(
        //   "Error while loading Parts Accessories JSON file: ",
        //   err.message
        // );
      });

    //komal 13-April-2023, Append Utility asset detail with manualcat object
    // Nirali : 27-04-2023, Appending Asset data at common ManualCat array
    if (ProductManualCat.Manualcat) {
      // await import(`../JSONData/${PartId}/EZ3_${PartId}_ManualCat_Asset.json`)
      // await axios.get(`${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_ManualCat_Asset.json`)
      await axios.get(`${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_ManualCat_Asset.json`)
        .then((res2) => {
          let assetJson = { ...res2.data };
          ProductManualCat.Manualcat.forEach((mcatObj, index) => {
            const assetObj = assetJson.Asset.find(
              (e) => e.Catalog === mcatObj.Catalog
            );
            if (assetObj) {
              let newObj = { ...mcatObj, ...assetObj };
              ProductManualCat.Manualcat[index] = newObj;
            }
          });
        })
        .catch((err) => {
          // console.log(
          //   "Error while loading Parts Accessories JSON file: ",
          //   err.message
          // );
        });
      // await import(
      //   `../JSONData/${PartId}/EZ3_${PartId}_ManualCat_Datasheet.json`
      // )
      await axios.get(
        `${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_ManualCat_Datasheet_${localStorage.getItem("lang")}.json`
        // `${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_ManualCat_Datasheet.json`
      )
        .then((res2) => {
          let datasheetJson = { ...res2.data };
          ProductManualCat.Manualcat.forEach((mcatObj, index) => {
            const DatasheetObj = datasheetJson.Datasheet.find(
              (e) => e.catalog === mcatObj.Catalog
            );
            if (DatasheetObj) {
              let newObj = { ...mcatObj, DatasheetObj: DatasheetObj };
              ProductManualCat.Manualcat[index] = newObj;
            }
          });
        })
        .catch((err) => {
          // console.log("Error while loading Datasheet JSON file: ", err.message);
        });
    }

    let SubsetJsonData = {};
    // await import(
    //   `../JSONData/${PartId}/${SubsetName}/EZ3_${PartId}_Parts_Accessories.json`
    // )

    const geLang = localStorage.getItem("lang") === "en_US"  ? "US" : "CA"

    await axios.get(
      `${process.env.PUBLIC_URL}/JSONData/${PartId}/${SubsetName}/EZ3_${PartId}_Parts_Accessories_${geLang}.json`
    )
      .then((res) => {
        let {data} = res
        
        // debugger
        data.Product_details[0].product_subset_name = (localStorage.getItem("lang") === "en_US" || localStorage.getItem("lang") === "en_CA") ? data.Product_details[0].product_subset_name : data.Product_details[0].product_subset_name_fr
        // console.log("data ",data);
        SubsetJsonData = { ...res.data };
      })
      .catch((err) => {
        console.log("Error while loading Parts Accessories JSON file: ",err.message);
      });

    let BreakerJsonData = {};
    // await import(
    //   `../JSONData/${PartId}/${SubsetName}/EZ3_${PartId}_Main_Breaker.json`
    // )
    await axios.get(
      `${process.env.PUBLIC_URL}/JSONData/${PartId}/${SubsetName}/EZ3_${PartId}_Main_Breaker_${geLang}.json`
    )
      .then((res) => {
        BreakerJsonData = { ...res.data };
      })
      .catch((err) => {
        // console.log("Error while loading Main Breaker JSON file: ", err.message);
      });

    let BranchBreakerJsonData = {};
    await axios.get(
      `${process.env.PUBLIC_URL}/JSONData/${PartId}/${SubsetName}/EZ3_${PartId}_Branch_Breaker_${geLang}.json`
    )
      .then((res) => {
        BranchBreakerJsonData = { ...res.data };
      })
      .catch((err) => {
        // console.log("Error while loading Branch Breaker JSON file: ",err.message)
      });

    let ExtraAccessoriesList = {};
    // Nirali : 20-04-2023, Fetching Extra accessories list data if available
    await axios.get(
      `${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_Extra_Accessories_List_${geLang}.json`
    )
      .then((res) => {
        ExtraAccessoriesList = { ...res.data };
      })
      .catch((err) => {
        // console.log("Error while loading Extra accessories JSON file: ",err.message);
      });

    // Managing Custom Groups for parts and Accessories
    let CustomGroups = [];
    // if (ProductManualCat.CustomGroups?.length) {
    //   for await (let grp of ProductManualCat.CustomGroups) {
    //     await import(
    //       `../JSONData/${PartId}/${SubsetName}/EZ3_${PartId}_Accessories_Groups/${grp.name}.json`
    //     )
    //       .then((res) => {
    //         CustomGroups.push(res);
    //       })
    //       .catch((err) => {
    //         console.log("Error while Checking Custom Groups: ", err.message);
    //       });
    //   }
    // }

    sethtmlUrl(`${process.env.PUBLIC_URL}/asset/Leftside/${SubsetName}/index.html`)

    setProductManualCatData({ ...ProductManualCat });
    FiltersOnJsonData({
      SubsetJsonData,
      BreakerJsonData,
      BranchBreakerJsonData,
      ExtraAccessoriesList,
      ProductManualCat,
      CustomGroups,
    });
  };

  const GetActiveCombArr = (CombArrFromJson, DeComManualcatArr) => {
    try {
      let ActiveCombArr = [];
      //if (!DeComManualcatArr.length) {
        ActiveCombArr = [...CombArrFromJson];
      // } else {
      //   CombArrFromJson.forEach((combObj) => {
      //     let newObj = { ...combObj };
      //     let CList = Object.keys(combObj).filter(
      //       (key) => key.indexOf("C") === 0
      //     );
      //     let AList = Object.keys(combObj).filter(
      //       (key) => key.indexOf("A") === 0
      //     );
      //     let InActivePartList = CList.filter((cItem) =>
      //       DeComManualcatArr.includes(combObj[cItem].split("|")[0])
      //     );
      //     if (InActivePartList.length === 0) {
      //       let InActiveAccList = AList.filter((cItem) =>
      //         DeComManualcatArr.includes(cItem)
      //       );
      //       InActiveAccList.forEach((i) => delete newObj[i]);
      //       ActiveCombArr.push({ ...newObj });
      //     }
      //   });
      //   // console.log("ActiveCombArr: ", JSON.stringify(ActiveCombArr));
      // }
      return ActiveCombArr;
    } catch (err) {
      console.log("error while preparing active Combinations: ", err.message);
      return [];
    }
  };

  const FiltersOnJsonData = ({
    SubsetJsonData,
    BreakerJsonData,
    BranchBreakerJsonData,
    ExtraAccessoriesList,
    ProductManualCat,
    CustomGroups,
  }) => {
    try {

      const DecommCatalogList = ProductManualCat.DeCommercialManualcat
        ? ProductManualCat.DeCommercialManualcat
        : [];
      const { Translations = [], Combinations: SubsetCombinations = [] } =
        SubsetJsonData;
      // Filter for all questions which are having some values at combinations
      const AllQuestionsList = [];
      Translations.filter((i) => i.Title).forEach((Q) => {
        if (
          SubsetCombinations.some(
            (c) => c[Q.Questions] !== "n/a" && c[Q.Questions] !== "N/A"
          )
        )
          AllQuestionsList.push(Q);
      });

      // Filter for independent questions
      const ParentQuestionList = AllQuestionsList.filter(
        (i) => i.Title && !i.DependentQuestion
      );
      let ActiveCombArr = GetActiveCombArr(
        SubsetCombinations,
        DecommCatalogList
      );
      SubsetJsonData["ActiveCombinations"] = [...ActiveCombArr];


      const {
        Translations: BreakerTranslations = [],
        Combinations: BreakerCombinations = [],
      } = BreakerJsonData;
      // Filter for all questions which are having some values at combinations
      const AllBreakerQueList = [];
      BreakerTranslations.filter((i) => i.Title).forEach((Q) => {
        if (
          BreakerCombinations.some(
            (c) => c[Q.Questions] !== "n/a" && c[Q.Questions] !== "N/A"
          )
        )
          AllBreakerQueList.push(Q);
      });
      let MainBrkActiveCombArr = GetActiveCombArr(
        BreakerCombinations,
        DecommCatalogList
      );
      BreakerJsonData["ActiveCombinations"] = [...MainBrkActiveCombArr];

      const {
        Translations: branchBreakerTranslations = [],
        Combinations: branchBrkCombinations = [],
      } = BranchBreakerJsonData;
      // Filter for all questions which are having some values at combinations
      const AllBranchBreakerQueList = [];
      branchBreakerTranslations
        .filter((i) => i.Title)
        .forEach((Q) => {
          if (
            branchBrkCombinations.some(
              (c) => c[Q.Questions] !== "n/a" && c[Q.Questions] !== "N/A"
            )
          )
            AllBranchBreakerQueList.push(Q);
        });

      let BranchBrkActiveCombArr = GetActiveCombArr(
        branchBrkCombinations,
        DecommCatalogList
      );
      BranchBreakerJsonData["ActiveCombinations"] = [...BranchBrkActiveCombArr];

      if (ExtraAccessoriesList.Accessories_group_data) {
        let DeCommercialCatalogs = ExtraAccessoriesList.DeCommercialManualcat
          ? ExtraAccessoriesList.DeCommercialManualcat
          : [];
        let AccArr = [];
        let grpName = "";
        let GrpObj = {};
        ExtraAccessoriesList.Accessories_group_data.forEach((item, index) => {
          if (!DeCommercialCatalogs.includes(item.Catalog)) {
            if (item.Groupname !== grpName) {
              if (grpName !== "")
                AccArr.push(JSON.parse(JSON.stringify(GrpObj)));
              grpName = item.Groupname;
              GrpObj = {};
              if (AccArr.length === 0)
                GrpObj["label"] = ExtraAccessoriesList.label;
              GrpObj["Groupname"] = item.Groupname;
              GrpObj["Data"] = [
                {
                  Catalog: item.Catalog,
                  Description: item.Description,
                },
              ];
            } else {
              GrpObj["Data"].push({
                Catalog: item.Catalog,
                Description: item.Description,
              });
            }
            // Adding prepared Group object for last item
            if (
              ExtraAccessoriesList.Accessories_group_data.length ===
              index + 1
            )
              AccArr.push(JSON.parse(JSON.stringify(GrpObj)));
          } else {
            if (
              ExtraAccessoriesList.Accessories_group_data.length ===
              index + 1 &&
              Object.keys(GrpObj).length &&
              GrpObj.Data?.length
            )
              AccArr.push(JSON.parse(JSON.stringify(GrpObj)));
          }
        });
    // console.log("ExtraAcc: ", AccArr);
        setExtraAccessoriesListJsonData([...AccArr]);

        /*  
    NOTE : JSON structure for ref
    [
        {
          Groupname: "ABC",
          Data: [
            {
              Catalog: "QOB2125SL",
              Description: "2-pole QOB Branch Mounted Sub-feed Lug Kit",
            },
            {
              Catalog: "QOB3125SL",
              Description: "3-pole QOB Branch Mounted Sub-feed Lug Kit",
            },
          ],
        },
        {
          Groupname: "DEF",
          Data: [
            { },
            { },
          ],
        }
      ];*/
      }

      if (ProductManualCat.CustomGroups?.length) {
        let AllQueList = [];
        let ParentQueList = [];
        CustomGroups.forEach((grpJsonData) => {
          const { Translations = [], Combinations: GrpCombinations = [] } =
            grpJsonData;
          // Filter for all questions which are having some values at combinations
          const GrpAllQuestionsList = [];
          Translations.filter((i) => i.Title).forEach((Q) => {
            if (
              GrpCombinations.some(
                (c) => c[Q.Questions] !== "n/a" && c[Q.Questions] !== "N/A"
              )
            )
              GrpAllQuestionsList.push(Q);
          });
          AllQueList.push(GrpAllQuestionsList);

          // Filter for independent questions
          const ParentQuestionList = GrpAllQuestionsList.filter(
            (i) => i.Title && !i.DependentQuestion
          );
          ParentQueList.push(ParentQuestionList);
          let ActiveCombArr = GetActiveCombArr(
            GrpCombinations,
            DecommCatalogList
          );
          grpJsonData["ActiveCombinations"] = [...ActiveCombArr];
        });
        setCustomGrpsJsonList(CustomGroups);
        setCustomGroupsAllQueList(AllQueList);
        setCustomGroupsQueList(ParentQueList);
      }

      setSubsetJson({ ...SubsetJsonData });
      setBreakerJson({ ...BreakerJsonData });
      setBranchBreakerJsonData({ ...BranchBreakerJsonData });
      setAllQuestionsList([...AllQuestionsList]);
      setBranchBreakerQueList([...AllBranchBreakerQueList]);
      setBreakerQueList([...AllBreakerQueList]);
      setConfigQuestionsList([...ParentQuestionList]);
      setParentQuestionList([...ParentQuestionList]);
    } catch (err) {
      console.log("Error while preparing JSON data: " + err.message);
    }
  };

  const getHeaderProductJSONData = async () => { 
    let PartId = "D09A";
    await axios.get(`${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_product_configurations_${localStorage.getItem("lang")}.json`)
    // await axios.get(`${process.env.PUBLIC_URL}/JSONData/${PartId}/EZ3_${PartId}_product_configurations.json`)
    .then((res) => {   
      const {product_subset,product_name} = res.data
      setProductSubset([...product_subset])
      setHeaderProductJson(product_name.name);      
    })
    .catch((err) => {
      
    }); 
    } 

  function updatePartsList(newPartList) {
    setParts([...newPartList]);
  }
  function updateAccList(newAccList) {
    setAccessories([...newAccList]);
  }
  function updateConfigQuestionsList(newQList) {
    setConfigQuestionsList([...newQList]);
  }
  function updateQueValueObj(newValObj) {
    setQueValueObj({ ...newValObj });
  }
  function updateBreakerValObj(newValObj) {
    setBreakerValueObj({ ...newValObj });
  }
  function updateBreakerQueList(newList) {
    setBreakerQueList({ ...newList });
  }
  function updateMainBreakerList(newBreakerArr) {
    setMainBreakersList([...newBreakerArr]);
  }
  function updateBranchBreakerValObj(newBranchBrkValObj) {
    setBranchBreakerValueObj({ ...newBranchBrkValObj });
  }
  function updateBranchBreakerList(newBranchBrkArr) {
    setBranchBreakersList([...newBranchBrkArr]);
  }
  function updateBranchBreakerQueList(newBranchBranchBrkArr) {
    setBranchBreakerQueList([...newBranchBranchBrkArr]);
  }
  function updateAccCartCount(newAccCount) {
    setAccessoriesCartCount(newAccCount);
  }
  function updateAccCartQtyInfoArr(newAccCartInfoArr) {
    setAccCartQtyInfoArr([...newAccCartInfoArr]);
  }
  function updateSubsetInfoDrawerOpen(DrawerState) {
    SetSubsetInfoDrawerOpen(DrawerState);
    localStorage.setItem("DrawerState",DrawerState)
  }
  function updateBranchBrkCartCount(newCount) {
    setBranchBreakerCartCnt(newCount);
  }
  function updateBranchBrkCartInfoArr(newInfoArr) {
    setBranchBrkCartInfoArr([...newInfoArr]);
  }
  function updateDistKey(newDistKey) {
    setDistKey(newDistKey);
  }
  function updateAccessoriesCartInfo(addcartInfoArr) {
    setAccessoriesCartInfoArr(addcartInfoArr);
  }

  return (
    <AppContext.Provider
      value={{
        loadSubsetJSONData,
        SubsetJsonData: SubsetJson,
        BreakerJsonData: BreakerJson,
        AllQuestionsList, // Product Subset: Flat questions (All parent and dependent questions)
        setAllQuestionsList,
        ParentQuestionList, // Product Subset: Parent questions only, not dependent
        ConfigQuestionsList, // Product Subset:Questions list to be display on screen, would get updated based on selection
        updateConfigQuestionsList,
        QueValueObj, // Object contains each values selected by user ( eg.{Q1:'Copper',Q2:25} )
        Parts, // Array of Parts list to be render on screen, would get updated based on values
        Accessories, // Array of Accessories list to be render on screen, would get updated based on values
        updatePartsList,
        updateAccList,
        updateQueValueObj,
        BreakerQueList, // Main Breaker: Questions List
        updateBreakerQueList,
        BreakerValueObj, // Main Breaker: config values Obj
        updateBreakerValObj,
        MainBreakersList, // Main Breaker: list that is being filtered
        updateMainBreakerList,
        BranchBreakerJsonData: BranchBreakerJson,
        BranchBreakerQueList, // Branch Breaker: Question List
        updateBranchBreakerQueList,
        BranchBreakerValueObj, // Branch Breaker: config value object
        BranchBreakersList, // Branch Breaker: List that is being filtered based on cart
        updateBranchBreakerValObj,
        updateBranchBreakerList,
        AccessoriesCartCount, // Count value of Accessories added to cart
        AccCartQtyInfoArr, // Accessories list info of cart
        updateAccCartCount,
        updateAccCartQtyInfoArr,
        IsSubsetInfoDrawerOpen,
        updateSubsetInfoDrawerOpen,
        BranchBreakerCartCnt,
        BranchBrkCartInfoArr,
        updateBranchBrkCartCount,
        updateBranchBrkCartInfoArr,
        DistKey,
        updateDistKey,
        updateAccessoriesCartInfo,
        AccessoriesCartInfoArr, // Accessories add cart Array
        setAccessoriesCartInfoArr,
        PartsListExpanded,
        setPartsListExpanded,
        AccListExpanded,
        setAccListExpanded,
        MainBrkListExpanded,
        setMainBrkListExpanded,
        BranchBrkListExpanded,
        setBranchBrkListExpanded,
        productForImageModal, //data for image modal
        setProductForImageModal,
        imageModalLoader, //loader for image modal
        setImageModalLoader,
        ExtraAccessoriesListJsonData, // Array list with extra accessories item
        ExtraAccList,
        setExtraAccList, // Extra accessories Cart list
        setExtraAccCartCount,
        ExtraAccCartCount, // Extra accessories cart count
        setExtraAccCartInfoArr, // Extra accessories cart information contains quantity value
        ExtraAccCartInfoArr,
        ExtraAccCatCartList,
        setExtraAccCatCartList,
        ExtraAccListExpanded,
        setExtraAccListExpanded,
        ProductManualCatData, // ManualCat data of selected Product
        setProductManualCatData,
        setExtraAccessoriesListJsonData,
        ExtraAccSectionExpanded,
        setExtraAccSectionExpanded,
        selectedCountry,
        setSelectedCountry,
        selectedCountryFlag,
        setSelectedCountryFlag,
        Product,
        toggleContents,
        setToggleContents,
        searchtxt, // for search product
        setSearchtxt,
        showGridView, // for Grid view
        setShowGridView,
        CustomGrpsJsonList,
        CustomGroupsAllQueList,
        CustomGroupsQueList,
        setCustomGroupsQueList,
        CustomGroupsValueObjList,
        setCustomGroupsValueObjList,
        CustomGrpCartItemsList,
        setCustomGrpCartItemsList,
        setCustomGroupsAllQueList,
        setCustomGrpsJsonList,
        InfoQueValueObj,
        setInfoQueValueObj,
        IsFromEZOwnHomePage,
        setIsFromEZOwnHomePage,
        SetSubsetInfoDrawerOpen,
        htmlUrl,
        sethtmlUrl,     //set html page with product subset path
        //p\Material Ui package export for shared-component
        Accordion,
        AccordionSummary,
        AccordionDetails,
        Typography,
        Button,
        List,
        ListItem,
        ListItemAvatar,
        Avatar,
        ListItemText,
        Tooltip,
        Dialog,
        DialogTitle,
        DialogContent,
        Chip,
        Stack,
        CircularProgress,
        Modal,
        ExpandMore,
        CheckCircle,
        TaskAlt,
        KeyboardDoubleArrowLeftSharp,
        Add,
        AddCircle,
        RemoveCircle,
        Cancel,
        InfoRounded,
        ImageZoom,
        HighlightOff,
        Box,
        getHeaderProductJSONData,
        HeaderProductJson,
        initialBooleanValue,
        setInitialBooleanValue,
        productSubset, 
        setProductSubset,
        DeleteOutlined,
        ReactImageMagnify
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
}
